<div class="around">
    <i class="fal fa-times close-btn" title="Đóng" (click)="close()"></i>
    <label class="layer-label">Layers</label>
    <ul class="esri-basemap-gallery__item-container" role="menu" style="margin: -24px">
        <li aria-selected="false" class="mt-0 esri-basemap-gallery__item" *ngFor="let layer of layers" title=""
            (click)="toggleLayer(layer)">
            <div class="pretty p-icon p-smooth layer-item">
                <div class="state p-primary-o">

                    <div *ngIf="layer?.id !== 'watershed' && layer?.className && layer.className !== 'district-headquarter'">
                        <i class="fas fa-eye m-1" *ngIf="layer.display"></i>
                        <i class="fas fa-eye-slash m-1" *ngIf="!layer.display"></i>
                        <div [class]="layer.className"></div>
                        <label class="ml-1">
                            {{ layer.name }}
                        </label>
                    </div>

                    <div *ngIf="layer?.id === 'District_headquarter' && layer?.className && layer.className === 'district-headquarter'">
                        <i class="fas fa-eye m-1" *ngIf="layer.display"></i>
                        <i class="fas fa-eye-slash m-1" *ngIf="!layer.display"></i>
                        <img [src]="'assets/images/point.png'" alt="{{ layer.name }} icon" class="district-headquarter">
                        <label class="ml-1">
                            {{ layer.name }}
                        </label>
                    </div>

                    <div *ngIf="layer?.id === 'watershed' && layer?.className">
                        <i class="fas fa-eye m-1" *ngIf="layer.display"></i>
                        <i class="fas fa-eye-slash m-1" *ngIf="!layer.display"></i>
                        <label class="ml-1">
                            {{ layer.name }}
                        </label>
                        <div>
                            <div *ngIf="layer.className.includes('watershed-Maijan')"
                                 [class]="'watershed-Maijan'"></div>
                            <label class="ml-1">
                                <!--{{ layer.name }} 1-->
                                Maijan
                            </label>
                            <br>
                            <div *ngIf="layer.className.includes('watershed-Sessa')"
                                 [class]="'watershed-Sessa'"></div>
                            <label class="ml-1">
                                <!--{{ layer.name }} 2-->
                                Sessa
                            </label>
                            <br>
                            <div *ngIf="layer.className.includes('watershed-Buridehing')"
                                 [class]="'watershed-Buridehing'"></div>
                            <label class="ml-1">
                                <!--{{ layer.name }} 3-->
                                Buridehing
                            </label>
                        </div>
                    </div>

                </div>
            </div>
        </li>
    </ul>
</div>
